export const fieldValidation = (fieldName, fieldValue) => {
  switch (fieldName) {
    case "EMAIL": {
      if (
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          fieldValue,
        )
      ) {
        if (fieldValue.length < 255) {
          return null;
        }
      }
      return 'Please enter a valid Email';
    }
    case "NAME": {
      // allow alphabets and some special characters
      if (/^[a-z .'-]+$/i.test(fieldValue,)) {
        if (fieldValue.length < 255) {
          return null;
        }
      }
      return 'Please enter a valid First and Last Name';
    }
    default: {
      // allow alphabets, digits and underscore
      if (/^([a-zA-Z0-9]+(?:_[a-zA-Z0-9]+)*)+$/.test(fieldValue,)) {
        if (fieldValue.length < 255) {
          return null;
        }
      }
      return 'Please provide a valid input';
    }
  }
};
